import { ToTitleCase } from './ToTitleCase.js';
import { SquashNulls } from './SquashNulls.js';

let getDefault = (modelDefaults, defaultKey, otherAttributes, fallback) => {
  // Check if we have an attribute and picklist key in the model defaults
  let attributeName = SquashNulls(modelDefaults, defaultKey, 'attribute');
  let picklistName = SquashNulls(modelDefaults, defaultKey, 'picklist');
  if (attributeName && picklistName) {
    // Try to get the specified picklist
    let picklist = SquashNulls(otherAttributes, attributeName, 'picklists', picklistName);
    if (!picklist && picklistName == '_all') {
      picklist = [];
      let picklists = SquashNulls(otherAttributes, attributeName, 'picklists');
      for (let key in picklists) {
        picklist.push(...picklists[key]);
      }
    }
    if (picklist) {
      // Return the picklist values
      return picklist.map((x) => x.value || x);
    }
  }
  // If no keys for a picklist was found, try to see if there is a value set
  else if (modelDefaults[defaultKey]) {
    // Return the model default if there is one
    return modelDefaults[defaultKey];
  }
  // Lastly, return the fallback
  return fallback;
};

export function ModelDefaults(modelDefaults, otherAttributes) {
  modelDefaults = modelDefaults || {};

  let ordering_attribute = getDefault(modelDefaults, 'ordering_attribute', otherAttributes, 'scid');
  let node_type_attribute = getDefault(modelDefaults, 'node_type_attribute', otherAttributes, 'node_type');
  let pole_node_types = getDefault(modelDefaults, 'pole_node_types', otherAttributes, ['pole']);
  let map_note_node_types = getDefault(modelDefaults, 'map_note_node_types', otherAttributes, ['map note', 'spatial note']);
  let reference_node_types = getDefault(modelDefaults, 'reference_node_types', otherAttributes, ['reference']);
  let reference_connection_types = getDefault(modelDefaults, 'reference_connection_types', otherAttributes, ['reference']);
  let connection_type_attribute = getDefault(modelDefaults, 'connection_type_attribute', otherAttributes, 'connection_type');
  let anchor_node_types = getDefault(modelDefaults, 'anchor_node_types', otherAttributes, ['existing anchor', 'new anchor']);
  let existing_anchor_node_type = getDefault(modelDefaults, 'existing_anchor_node_type', otherAttributes, 'existing anchor');
  let proposed_anchor_node_type = getDefault(modelDefaults, 'proposed_anchor_node_type', otherAttributes, 'new anchor');
  let anchor_spec_attribute = getDefault(modelDefaults, 'anchor_spec_attribute', otherAttributes, 'anchor_spec');
  let downguy_connection_types = getDefault(modelDefaults, 'downguy_connection_types', otherAttributes, ['down guy']);
  let proposed_downguy_connection_types = getDefault(modelDefaults, 'proposed_downguy_connection_types', otherAttributes, [
    'proposed down guy'
  ]);
  // Default to combining the pole_node_types and reference_node_types lists
  let forward_back_span_node_types = getDefault(
    modelDefaults,
    'forward_back_span_node_types',
    otherAttributes,
    pole_node_types.concat(reference_node_types)
  );
  let spans_forward_back_span_node_types = getDefault(modelDefaults, 'spans_forward_back_span_node_types', otherAttributes, [
    ...forward_back_span_node_types
  ]);
  let directory_node_types = getDefault(modelDefaults, 'directory_node_types', otherAttributes, pole_node_types);

  let ordering_attribute_label = ToTitleCase(ordering_attribute);
  if (ordering_attribute == 'scid') ordering_attribute_label = ordering_attribute_label.toUpperCase();

  return {
    ordering_attribute,
    ordering_attribute_label,
    node_type_attribute,
    pole_node_types,
    map_note_node_types,
    reference_node_types,
    connection_type_attribute,
    reference_connection_types,
    anchor_node_types,
    existing_anchor_node_type,
    proposed_anchor_node_type,
    anchor_spec_attribute,
    downguy_connection_types,
    proposed_downguy_connection_types,
    forward_back_span_node_types,
    spans_forward_back_span_node_types,
    directory_node_types
  };
}
